import { useContext } from 'react';
import { FornecedorContext } from '../contexts/FornecedorContext';
import { FornecedorContextData } from '../protocols';

export const useFornecedorContext = (): FornecedorContextData => {
  const ctx = useContext(FornecedorContext);
  return ctx;
};
